import styled from 'styled-components';
import { BUTTON_VARIANTS } from 'ui/button';
import { Close16 } from 'ui/icons';
import { BasicFilterSelect } from 'ui/selects';
import { fonts } from 'ui/theme';

import { WrapperJson, InlineFormField, DeleteButton } from './KeyValuePair.styled';

import type { WebhookUserJsonField, UserFieldOption } from '../types';

export const MonospaceSelect = styled(BasicFilterSelect)`
  font-family: ${fonts.monospaced} !important;
`;

type Props = {
  id: string;
  body: WebhookUserJsonField;
  hasError?: boolean;
  editable: boolean;
  canDelete?: boolean;
  onChange: (field: WebhookUserJsonField) => void;
  options: UserFieldOption[];
  onDelete: () => void;
};

export const JsonUserField = ({
  id,
  body,
  editable,
  options,
  canDelete = true,
  onChange,
  onDelete,
}: Props) => {
  return (
    <WrapperJson>
      <InlineFormField hasError={false}>
        {editable && (
          <MonospaceSelect
            id={id}
            data-formfieldtype="select"
            placeholder="Select a field"
            options={options}
            // @ts-expect-error
            onSelect={([value]) => onChange({ value })}
            defaultValues={body ? [body.field] : []}
          />
        )}
      </InlineFormField>
      {canDelete && (
        <DeleteButton onClick={onDelete} variant={BUTTON_VARIANTS.GHOST}>
          <Close16 />
        </DeleteButton>
      )}
    </WrapperJson>
  );
};
